<template>
  <EmdFormGroup
    :label="$t('phone-type')"
    required
    :state="getState($v.recipient.phone_numbers.type)"
    :feedbacks="feedbacks($v.recipient.phone_numbers.type)"
  >
    <EmdSelect
      @click="() => $v.recipient.phone_numbers.type.$touch()"
      v-model="recipient.phone_numbers[0].type"
      name="phone_type"
    >
      <option value="fixed">{{ $t('phone-type-fixed') }}</option>
      <option value="mobile">{{ $t('phone-type-mobile') }}</option>
    </EmdSelect>
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdSelect } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { recipientValidationsGeneral } from '../validations'
export default {
  name: 'PhoneTypeInput',
  components: {
    EmdFormGroup,
    EmdSelect
  },
  data: () => ({
    getState,
    feedbacks,
    type: 'fixed'
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: recipientValidationsGeneral }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "phone-type": "Tipo de telefone",
      "phone-type-mobile": "Celular",
      "phone-type-fixed": "Fixo"
    },
    "en-US": {
      "phone-type": "Phone Type",
      "phone-type-mobile": "Mobile",
      "phone-type-fixed": "Fixed line"
    }
  }
</i18n>
